import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-salas-edit',
  templateUrl: './salas-edit.component.html',
  styleUrl: './salas-edit.component.css',
  standalone: false
})
export class SalasEditComponent implements OnInit {


  constructor(
    private readonly schemaBuilderService: SchemaBuilderService,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.loadFields();
  }

  private loadFields(): void {
    this.schemaBuilderService.getFieldSchema("rooms").subscribe((schema: PoPageDynamicEditField[]) => {
      this.fields = schema.filter(field => field.property !== 'deviceAlias');
    });
  }

  public readonly serviceApi = environment.apiUrl + '/v1/rooms';

  public readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Controle de Acesso' }, { label: 'Salas', link: '/rooms' }, { label: 'Edição' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
    save: 'rooms',
  };

  fields: PoPageDynamicEditField[] = []
}

